<template>
    <Appstore/>
</template>

<script>
import { Appstore } from 'shared'

export default {
    name: 'appstore1',
    components: {
        Appstore
    },
    created() {
        this.$store.commit('getAppId', [
            {
                value: 6016,
                label: '娱乐'
            }
        ])
    }
}
</script>